import LeftMenu from './LeftMenu';

export default LeftMenu;